import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectOngoingQueueCallKeyForTicket,
    selectWaitingQueueItemKeyForTicket,
} from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';

import SectionHeaderOngoingCall from './SectionHeaderOngoingCall';
import SectionHeaderQueuePosition from './SectionHeaderQueuePosition';
import SectionHeaderTime from './SectionHeaderTime';

type Props = {
    ticketKey: TicketKey;
};

// While the ticket is live somewhere in the PBX, the timestamp slot shows
// that instead: queue position while waiting, call duration while a call
// connected to the ticket is ongoing.
//
// The ongoing call wins when both match. The two states are fed by separate
// TOP events — the call goes 'Up' on NewState, the queue entry disappears on
// QueueLeave — so an answered call can briefly still be listed as waiting,
// and 'Up' is the later of the two states.
const SectionHeaderStatus = ({ ticketKey }: Props) => {
    const waitingQueueItemKey = useAppSelector((state) =>
        selectWaitingQueueItemKeyForTicket(state, ticketKey),
    );
    const ongoingQueueCallKey = useAppSelector((state) =>
        selectOngoingQueueCallKeyForTicket(state, ticketKey),
    );

    if (ongoingQueueCallKey) {
        return (
            <SectionHeaderOngoingCall
                ongoingQueueCallKey={ongoingQueueCallKey}
            />
        );
    }

    if (waitingQueueItemKey) {
        return (
            <SectionHeaderQueuePosition
                ticketKey={ticketKey}
                waitingQueueItemKey={waitingQueueItemKey}
            />
        );
    }

    return <SectionHeaderTime ticketKey={ticketKey} />;
};

export default React.memo(SectionHeaderStatus);
